import { render, staticRenderFns } from "./PerfilWhatsapp.vue?vue&type=template&id=f57af800"
import script from "./PerfilWhatsapp.vue?vue&type=script&lang=js"
export * from "./PerfilWhatsapp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../go/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports